import { AfterViewInit, ChangeDetectorRef, Component, OnDestroy, OnInit, QueryList, ViewChildren, ViewEncapsulation, EventEmitter } from '@angular/core';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { FusePerfectScrollbarDirective } from '@fuse/directives/fuse-perfect-scrollbar/fuse-perfect-scrollbar.directive';
import { FuseSidebarService } from '@fuse/components/sidebar/sidebar.service';
import { FuseConfirmDialogComponent } from '@fuse/components/confirm-dialog/confirm-dialog.component';

import { fuseAnimations } from '@fuse/animations';

///IDIOMAS
import { lang_certificar } from 'app/idiomas/i18n/certificar/certificar.lang';
import { lang_modales } from 'app/idiomas/i18n/modales/modales.lang';
import { FuseTranslationLoaderService } from '@fuse/services/translation-loader.service';
import {TranslateService} from '@ngx-translate/core';

import *  as $ from 'jquery';
import { MatDialog, MatDialogRef,MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ModalComponent } from 'app/main/pagina/modal/modal.component';
import { AdicionalesService } from 'app/main/wizard-cgo/services/adicionales.service';
import { WizardService } from 'app/main/wizard-cgo/services/wizard.service';
import * as backInter from 'app/auth/auth-data.model';
import Swal from 'sweetalert2';
import {MatSnackBar} from '@angular/material/snack-bar';
import { PreguntasComponent } from './preguntas/preguntas.component';
import { ProgramacionService } from "app/main/wizard-cgo/services/programacion.service";

interface adverModal {
  tipo: number;
  mensaje: string;
  diccionario: string;
  confirma: boolean;
};


@Component({
    selector     : 'adicionales',
    templateUrl  : './adicional.component.html',
    styleUrls    : ['./adicional.component.scss'],
    encapsulation: ViewEncapsulation.None,
    animations   : fuseAnimations
})
export class AdicionalComponent implements OnInit {

  // Datos certificar vigente
  productoCertificar: backInter.prodCert;
  productoFocus: backInter.prodFocusArea;
  preguntasAdicionalesFocus: backInter.getPreguntasAdiocnalesFocus;
  preguntasTraduccionesAdicionalesFocus: backInter.respuestaTraduccionesPreguntasAdicionalesFocus;
  banderaEncuestaFocus: backInter.actualizaBanderaFocus;

  // IDIOMAS RECUPERADOS DE BD
  idiomas: backInter.getIdiomas;
  // preguntas adicionales de bd
  preguntasAdicionales: backInter.getAdicionales;

  //boolean sin preguntas adicionales
  sinAdicionales = false;

  //boolean cargando
  cargando = false;
  //boolean paso completo
  pasoCompleto = false;
  flag=false;
  btnBanderaEncuesta:false;
  traduccionesPreguntas:boolean;
  traduccionesPreguntasOpciones:boolean;
  sinIdiomasAdiconales=false;
  bloqueaSeccionAdicional=false;
  // @Output() ActualizaPasoCompleto: EventEmitter<boolean> = new EventEmitter();
  // //boolean Adiconales
  // adicionales=false;
  statusModal:number;
  focusSinAdicionales:boolean=false;
  instituto:any;
  validacionEncuestaPrincipal:boolean;
  OcultarTraducionSinAdicio=true;

  userData:any;
  validationUser:boolean=false;
  desbloqueoEstatus:boolean=false;
  constructor(
    private adicionalesService: AdicionalesService,
    public dialog: MatDialog,
    private _fuseTranslationLoaderService: FuseTranslationLoaderService,
    private translateSrv: TranslateService,
    private wizardService: WizardService,
    private programacionService: ProgramacionService,
    private _snackBar: MatSnackBar,
  )
  {
    lang_certificar.forEach((locale) => {
      this._fuseTranslationLoaderService.loadTranslations(locale);
    });
    lang_modales.forEach((locale) => {
        this._fuseTranslationLoaderService.loadTranslations(locale);
    });

    if(localStorage.getItem('userBypass')){
    this.userData=JSON.parse(localStorage.getItem('userBypass'));
    // console.log(this.userData.level);
    if(this.userData.level==3 || this.userData.level==2){
      this.validationUser=true;
    }
    else{
      this.validationUser=false;
    }
    }
  }

  ngOnInit() {
    // $(document).ready(function(){
    //   $(".finishBt").width($(".finishBt").parent().width());
    // });
    // $(window).resize(function(){
    //   $(".finishBt").width($(".finishBt").parent().width());
    // });
this.obtieneInstituto();
    this.obtieneCertificarActual();
   this.getActualizaBanderaEvaluarEncuesta();

  }

  openSnackBar(message: string, action: string) {
    this._snackBar.open(message, action, {
      duration: 2000,
    });
  }
  obtieneInstituto(){
    let institutoAct = this.wizardService.getInstituto();
    // console.log(institutoAct);
    switch(institutoAct){
      case '1': case 'MX': this.instituto = 'MX'; break;
case '2': case 'CAyC': this.instituto = 'CAyC'; break;
case '3': case 'HK': this.instituto = 'HK'; break;
case '4': case 'SGP': this.instituto = 'SGP'; break;
case '5': case 'TK': this.instituto = 'TK'; break;
case '6': case 'FL': this.instituto = 'FL'; break;
case '11': case 'BR': this.instituto = 'BR'; break;
    }
    console.log("Instituto "+this.instituto);
  }

  eventsSubject: Subject<any> = new Subject<any>();

  emitEventToChild() {
    this.eventsSubject.next(this.preguntasAdicionalesFocus);
  }

  emitActualizacionTraducciones(){
    let datos:any= {seccion: 7, empresaId:localStorage.getItem('companyID')};
    console.log(datos);
    this.adicionalesService.getTraduccionesAdicionalFocus(datos).subscribe( (data:backInter.respuestaTraduccionesPreguntasAdicionalesFocus) => {
      this.preguntasTraduccionesAdicionalesFocus = data;
      this.eventsSubject.next(this.preguntasTraduccionesAdicionalesFocus);
    });
  }


  obtieneCertificarActual(){
    /// obtiene el producto certificar vigente
    this.adicionalesService.getProdCertAct().subscribe((data:backInter.infoProductos) => {
      let prodsFocusArea:backInter.prodFocusArea[] = data.productosFocusArea;
      var BreakException = {};
      try {
        prodsFocusArea.forEach( (producto) => {
          let fecha = producto.fechaFocus;
          let idProducto = producto.idFocusArea;
          console.log(fecha+'-'+parseInt(localStorage.getItem('fechaProducto'))+'*'+idProducto+'-'+ localStorage.getItem('productoID'));
          if(fecha == parseInt(localStorage.getItem('fechaProducto')) && idProducto == localStorage.getItem('productoID')){
            this.productoFocus = producto;
            this.getEstatusDesbloqueo();
            console.log(this.productoFocus);
            throw BreakException;
          }
        });
      } catch (e) {
          if (e !== BreakException) throw e;
      };
      //obtiene el status del paso adicionales del certificar vigente
      this.adicionalesService.getStatusAdicionalesFocus(localStorage.getItem('encuestaID')).subscribe( (data: backInter.getStatusIndiv) => {
        if(data.estatus === 3)
          this.pasoCompleto = true;

      });
      this.obtieneIdiomasGuardados();
      //obtiene las preguntas adicionales guardadas
      this.obtieneAdicionales();
      this.obtieneTraduccionesAdicionalesFocus();
      this.getStatusModal();
      this.getStatusValidacionEncuesta();
    }, error  => {
      console.log("error al recuperar certificar vigente");
    });
  }

  /////////funcion que  trae el estatus  si es requerido Verificar la Encuesta///////////
    getStatusValidacionEncuesta(){
  let empresaId=localStorage.getItem('companyID');
  let productoId=localStorage.getItem('productoID');
  console.log("hasta aqui entro");
  this.programacionService.getvalidacionEncuestaRequeridaFocusArea(empresaId,productoId).subscribe((respuesta:any) => {
      console.log("Bandera:",respuesta);
      this.validacionEncuestaPrincipal= respuesta.validacion;
      console.log(this.validacionEncuestaPrincipal);

    });
    }

  obtieneIdiomasGuardados(){
    // this.adicionalesService.getIdiomas().subscribe( (data: backInter.getIdiomas) => {
    let fechaProducto: backInter.getIdiomaFechas = {fechaFocus:this.productoFocus.fechaFocus};
    this.adicionalesService.getListaIdiomasFocus().subscribe( (data: backInter.getIdiomas) => {
      this.idiomas = data;
      console.log("estos son los idiomas de focu ",this.idiomas);

if(data.idiomas.length>0){
  this.sinIdiomasAdiconales=true;
  console.log(this.sinIdiomasAdiconales);


}else{
  this.sinIdiomasAdiconales=false;
  console.log(this.sinIdiomasAdiconales);
}

      // console.log(data);
      // console.log(this.idiomas);
    });
  }


  obtieneAdicionales(actualizacion?:boolean){
    if(!actualizacion)
      this.cargando = true;

    this.adicionalesService.getPreguntasAdicionalesFocus().subscribe( (data: backInter.getPreguntasAdiocnalesFocus) => {
      this.preguntasAdicionalesFocus = data;
      console.log(data);

      if (this.preguntasAdicionalesFocus.preguntas.length==0) {
        this.OcultarTraducionSinAdicio=true;

      }
      this.preguntasAdicionalesFocus.preguntas.forEach(element => {
        if (element.pregunta=="sin adicionales") {
          this.OcultarTraducionSinAdicio=false;
        }else{
          this.OcultarTraducionSinAdicio=true;
        }
        console.log("pestaña traduccion",this.OcultarTraducionSinAdicio);


      });

      // this.emitEventToChild();
      console.log("adicionales obtenidos:");
      if(actualizacion){
        this.emitActualizacionTraducciones();
        this.obtieneTraduccionesAdicionalesFocus();
      }
      else{
        this.cargando = false;
      }
    });
  }

  actualizarAdicionales(orden: boolean){
    if(orden){
      // this.preguntasAdicionales = null;
      this.obtieneAdicionales(true);
    }
  }

  sinAdicionalesFocus(orden: boolean){
    console.log("entro este visne de bloqueo");
    this.focusSinAdicionales=orden;
  this.obtieneTraduccionesAdicionalesFocus();
  this.obtieneAdicionales();
  }

  actualizaStatusSinAdicionales(status:boolean){
    this.focusSinAdicionales = status;
    this.obtieneAdicionales();
    this.obtieneTraduccionesAdicionalesFocus();
  }



  completarPaso(){
    // switch (this.instituto) {
    //   case 'MX':
  if (this.validacionEncuestaPrincipal) {
      if(this.banderaEncuestaFocus.estatusVerificacion==3){
      console.log("encuesta ya requiere validacion ");
      this.aletaRestric('ADICIONALES.COMPLETAR',true);
    }else{
      let texto = 'MODALES.MENSAJES.WIZARD.FOCUS.MODAL-AUNAUTORIZACION'
      let rspEnterado = 'MODALES.MENSAJES.WIZARD.FOCUS.BTN-ENTERADO'
      this.translateSrv.get(texto).subscribe((res: string) => { texto = res; });
      this.translateSrv.get(rspEnterado).subscribe((res: string) => { rspEnterado = res; });

        Swal.fire({
          title: texto,
          icon: 'warning',
          
          confirmButtonText: rspEnterado,

      })
      }
console.log("si requiere Validacion");

         }else{
    console.log("encuesta no  requiere validacion ");

if (this.preguntasAdicionalesFocus.preguntas.length>0 || this.focusSinAdicionales) {
console.log(this.traduccionesPreguntas);
console.log(this.traduccionesPreguntasOpciones);

  if(this.traduccionesPreguntas && this.traduccionesPreguntasOpciones) {

     this.aletaRestric('ADICIONALES.COMPLETAR',true);

          this.bloqueaSeccionAdicional=true;

      }else{
        let rspSi = 'MODALES.ACCIONES.aceptar';
        let texto = 'MODALES.VALIDACION.ERROR1';
        this.translateSrv.get(texto).subscribe((res: string) => { texto = res; });
        this.translateSrv.get(rspSi).subscribe((res: string) => { rspSi = res; });
        Swal.fire({
          icon: 'warning',
          title: texto,
          confirmButtonText: rspSi,
          confirmButtonColor: '#e40601'
        });
      }

}else{
  this.aletaRestric('ADICIONALES.NADA',null,'warning');
}

}

    //
    //     break;
    //
    //   default:
    //
    //     break;
    // }

  }

  enviaOrdenWizard(){
    this.wizardService.puenteDatos("100"); //100 = actualiza los status de los steps
  }

  getEstatusDesbloqueo(){
    this.wizardService.estatusDesbloqueoPasos(this.productoFocus.idFocusArea).subscribe((respuesta:any) => {
      // console.log("respDesbloqueo:",respuesta);
      if(respuesta.desbloqueo==true){
        this.desbloqueoEstatus=true;
      }
      else{
        this.desbloqueoEstatus=false;
      }
    });
  }

  desbloquearAdicionales(){
    let tituloDesbloquear = 'MODALES.MENSAJES.WIZARD.CERTIFICAR.ADICIONALES.TITULO_DESBLOQUEAR';
    let confirmar = 'MODALES.MENSAJES.WIZARD.CERTIFICAR.ADICIONALES.BOTON_CONFIRM';
    let cancelar = 'MODALES.MENSAJES.WIZARD.CERTIFICAR.ADICIONALES.BOTON_CANCEL';
    let succes = 'MODALES.MENSAJES.WIZARD.CERTIFICAR.ADICIONALES.SUCCES';
    let bloqueado = 'MODALES.MENSAJES.WIZARD.CERTIFICAR.ADICIONALES.BLOQUEADO';
    let cerrar = 'MODALES.MENSAJES.WIZARD.CERTIFICAR.ADICIONALES.CERRAR';
    this.translateSrv.get(tituloDesbloquear).subscribe((res: string) => { tituloDesbloquear = res; });
    this.translateSrv.get(confirmar).subscribe((res: string) => { confirmar = res; });
    this.translateSrv.get(cancelar).subscribe((res: string) => { cancelar = res; });
    this.translateSrv.get(succes).subscribe((res: string) => { succes = res; });
    this.translateSrv.get(bloqueado).subscribe((res: string) => { bloqueado = res; });
    this.translateSrv.get(cerrar).subscribe((res: string) => { cerrar = res; });
    if(this.pasoCompleto==true){
        Swal.fire({
        title: tituloDesbloquear,
        icon: 'warning',
        showCancelButton: true,
reverseButtons: true,
        
        
        confirmButtonText: confirmar,
        cancelButtonText: cancelar
      }).then((result) => {
        if (result.value) {
          this.adicionalesService.desbloquearPasoAdicionalesFocus(localStorage.getItem('encuestaID')).subscribe( (data: backInter.RespuestaGen) => {
             console.log(data);
             if(data.message == '214'){
               this.pasoCompleto = false;
               this.enviaOrdenWizard();
               this.openSnackBar(succes,"OK");
              /* Swal.fire({
               icon: 'success',
               title: succes,
               showConfirmButton: true,
               
               confirmButtonText: cerrar,
               })*/
             };
          });
        }
      });
      }
      else{
        Swal.fire({
        icon: 'warning',
        title: bloqueado,
        showConfirmButton: true,
        
        confirmButtonText: cerrar,
        })
      }
  }

  aletaRestric(mensaje:string, confirmar?:boolean, tipo?:string){

    let texto = 'MODALES.MENSAJES.WIZARD.CERTIFICAR.'+mensaje;
    let rspSi = 'MODALES.ACCIONES.aceptar';
    let rspNo = 'MODALES.ACCIONES.cancelar';
    this.translateSrv.get(texto).subscribe((res: string) => { texto = res; });
    this.translateSrv.get(rspSi).subscribe((res: string) => { rspSi = res; });
    this.translateSrv.get(rspNo).subscribe((res: string) => { rspNo = res; });

    if(confirmar){
      Swal.fire({
        title: texto,
        icon: 'warning',
        showCancelButton: true,
reverseButtons: true,
        
        
        confirmButtonText: rspSi,
        cancelButtonText: rspNo
      }).then((result) => {
        if (result.value) {
          this.adicionalesService.guardaStatusAdicionalesFocus(localStorage.getItem('encuestaID')).subscribe( (data: backInter.RespuestaGen) => {
            if(data.message == '214'){
              this.aletaRestric('ADICIONALES.'+data.message,null,'success');
              this.pasoCompleto = true;
              this.enviaOrdenWizard();
            };
          });
        }
      });
    }
    else{
      if(tipo == 'warning'){
        Swal.fire({
          icon: 'warning',
          title: texto,
          confirmButtonColor: '#e40601'
        });
      }
      else if(tipo == 'success'){
        this.openSnackBar(texto,"OK");
        /*Swal.fire({
          icon: 'success',
          title: texto,
          confirmButtonText: rspSi,
          confirmButtonColor: '#e40601'
        });*/
      }
    }

  }

  obtieneTraduccionesAdicionalesFocus(){
    let datos:any= {seccion: 7, empresaId:localStorage.getItem('companyID')};
    this.adicionalesService.getTraduccionesAdicionalFocus(datos).subscribe( (data:backInter.respuestaTraduccionesPreguntasAdicionalesFocus) => {
      this.preguntasTraduccionesAdicionalesFocus = data;
      console.log(this.preguntasTraduccionesAdicionalesFocus)
      if (this.preguntasTraduccionesAdicionalesFocus.arrayMostrar.length==0) {
          console.log("djsbsa");
        this.traduccionesPreguntas= true;
        this.traduccionesPreguntasOpciones= true;
      }else{
      this.preguntasTraduccionesAdicionalesFocus.arrayMostrar.forEach(element => {
        element.preguntas.forEach(elementOpciones => {
          console.log(elementOpciones);
          if(elementOpciones.tipoRespuesta!=3){
            console.log("entro estes vise con adicionalesTraduccion ");
            if(elementOpciones.traduccion==""){
              this.traduccionesPreguntas= false;
              console.log(this.traduccionesPreguntas);

            }else{
              this.traduccionesPreguntas= true;
              console.log(this.traduccionesPreguntas);


            }
            if(elementOpciones.opciones.length==0){
              this.traduccionesPreguntasOpciones= true;
              console.log(this.traduccionesPreguntasOpciones);

            }

            elementOpciones.opciones.forEach(element => {
                if(element.traduccion==""){
                  this.traduccionesPreguntasOpciones= false;
                  console.log(this.traduccionesPreguntasOpciones);
                }else{
                  this.traduccionesPreguntasOpciones= true;
                    console.log(this.traduccionesPreguntasOpciones);
                }
           });
         }else{
           console.log("entro este visne sin adicionalesTraduccion ");
           this.traduccionesPreguntas= true;
           this.traduccionesPreguntasOpciones= true;

         }



     });

      });
    }


      //
      // if(this.preguntasTraduccionesAdicionalesFocus.arrayMostrar.length >0){
      //   this.sinIdiomasAdiconales=true;
      //   console.log(this.sinIdiomasAdiconales);
      //
      //
      // }else{
      //   this.sinIdiomasAdiconales=false;
      //   console.log(this.sinIdiomasAdiconales);
      // }


    });
  }




  actualizaBanderaEvaluarEncuesta(){

if (this.preguntasAdicionalesFocus.preguntas.length>0 || this.focusSinAdicionales) {
if(this.traduccionesPreguntas && this.traduccionesPreguntasOpciones) {
    let texto = 'MODALES.MENSAJES.WIZARD.FOCUS.MODAL-AUTORIZACION'
    let rspEnterado = 'MODALES.MENSAJES.WIZARD.FOCUS.BTN-ENTERADO'
    this.translateSrv.get(texto).subscribe((res: string) => { texto = res; });
    this.translateSrv.get(rspEnterado).subscribe((res: string) => { rspEnterado = res; });

      // let datos={estatusVerificacion:2}
      let datos={estatusVerificacion:2,texto:'NOTIFICACIONES.AUTORI-ENCUESTA.AUTORIZAR-ENCUESTA'}
      this.adicionalesService.actulizaBanderaEncuestaFocus(datos).subscribe( (data: any) => {
        console.log(data);

        Swal.fire({
                icon: 'success',
                title: texto,
                confirmButtonText: rspEnterado,
                confirmButtonColor: '#e40601'
              });
              this.bloqueaSeccionAdicional=true;
        this.getActualizaBanderaEvaluarEncuesta();
      });
    }else{
      let rspSi = 'MODALES.ACCIONES.aceptar';
      let texto = 'MODALES.VALIDACION.ERROR1';
      this.translateSrv.get(texto).subscribe((res: string) => { texto = res; });
      this.translateSrv.get(rspSi).subscribe((res: string) => { rspSi = res; });
      Swal.fire({
        icon: 'warning',
        title: texto,
        confirmButtonText: rspSi,
        confirmButtonColor: '#e40601'
      });
    }
  }else{
      this.aletaRestric('ADICIONALES.NADA',null,'warning');
  }
  }

  getActualizaBanderaEvaluarEncuesta(){
    let datos={productoId:localStorage.getItem('productoID')};
    this.adicionalesService.getActulizaBanderaEncuestaFocus(datos).subscribe( (data: backInter.actualizaBanderaFocus) => {
      console.log(data);
      this.banderaEncuestaFocus=data;

      });
  }

  /////Modales por secciones
  getStatusModal(){
    let datos={
      encuestaID: localStorage.getItem('encuestaID'),
      adicionales: 1
    };
    console.log(datos);
    this.wizardService.getStatusModalFocus(datos).subscribe( (data: backInter.getStatusModal) => {
      this.statusModal=data.estatus;
      if(data.estatus==1){
            this.modalInformativo('ADICIONALES');
      }
    });
  }
  updateStatusModal(){
    let datos={
      encuestaID: localStorage.getItem('encuestaID'),
      adicionales: 2  };
    // console.log(datos);
    this.wizardService.updateStatusModalFocus(datos).subscribe( (data: any) => {
      // console.log(data);
    });
  }

  modalInformativo(OPCIONMODAL:string){
    let texto = 'MODALES.MENSAJES.WIZARD.CERTIFICAR.'+OPCIONMODAL+'.INFORMATIVO';
    let botonModal = 'MODALES.ACCIONES.INFORMATIVO';
    let rspSi = 'MODALES.ACCIONES.aceptar';
    this.translateSrv.get(rspSi).subscribe((res: string) => { rspSi = res; });
    this.translateSrv.get(texto).subscribe((res: string) => { texto = res; });
    this.translateSrv.get(botonModal).subscribe((res: string) => { botonModal = res; });
    Swal.fire({
      icon: 'info',
      title: texto,
      input: "checkbox",
      inputPlaceholder: botonModal,
      
      confirmButtonText: rspSi,
      allowOutsideClick: false
    }).then((result) => {
      if (result.value == 1){
        this.updateStatusModal();
      }
    });
  }

}
